
const header = document.querySelector('.peak-header');
const progressBar = document.querySelector('.scroll-progress span');
const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
function updateScrollUI(){
  const top = window.scrollY || window.pageYOffset;
  const total = document.documentElement.scrollHeight - window.innerHeight;
  const progress = total > 0 ? (top / total) * 100 : 0;
  if(progressBar) progressBar.style.width = progress + '%';
  if(header) header.classList.toggle('scrolled', top > 16);
}
window.addEventListener('scroll', updateScrollUI, {passive:true});
window.addEventListener('resize', updateScrollUI);
updateScrollUI();
requestAnimationFrame(() => document.body.classList.add('ready'));

document.querySelectorAll('.faq-item').forEach((item) => {
  const btn = item.querySelector('.faq-q');
  const answer = item.querySelector('.faq-a');
  const sync = () => {
    answer.style.maxHeight = item.classList.contains('open') ? answer.scrollHeight + 'px' : '0px';
  };
  sync();
  btn.addEventListener('click', () => {
    item.classList.toggle('open');
    sync();
  });
});

const revealTargets = document.querySelectorAll('main section:not(.hero), .fact, .benefit, .mosaic-card, .tile, .story-panel, .product-image, .step, .faq-item, .cta');
revealTargets.forEach((el, i) => {
  if (!el.classList.contains('reveal')) el.classList.add('reveal');
  el.style.transitionDelay = Math.min((i % 4) * 0.08, 0.24) + 's';
});
if (!prefersReduced && 'IntersectionObserver' in window) {
  const io = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('in-view');
        io.unobserve(entry.target);
      }
    });
  }, { threshold: 0.14, rootMargin: '0px 0px -40px 0px' });
  document.querySelectorAll('.reveal').forEach(el => io.observe(el));
} else {
  document.querySelectorAll('.reveal').forEach(el => el.classList.add('in-view'));
}

const hero = document.querySelector('.hero');
const heroImage = document.querySelector('.hero-media img');
const heroBadge = document.querySelector('.hero-badge');
if (hero && heroImage && heroBadge && !prefersReduced) {
  hero.addEventListener('mousemove', (e) => {
    const rect = hero.getBoundingClientRect();
    const x = ((e.clientX - rect.left) / rect.width) - 0.5;
    const y = ((e.clientY - rect.top) / rect.height) - 0.5;
    heroImage.style.transform = `scale(1.06) translate3d(${x * -18}px, ${y * -14}px, 0)`;
    heroBadge.style.transform = `translate3d(${x * 14}px, ${y * 10}px, 0)`;
  });
  hero.addEventListener('mouseleave', () => {
    heroImage.style.transform = '';
    heroBadge.style.transform = '';
  });
}

document.querySelectorAll('.hamb').forEach(b=>b.addEventListener('click',()=>{const n=document.querySelector('.peak-nav-mobile');if(n){const open=n.classList.toggle('open');b.setAttribute('aria-expanded',String(open));}}));

document.querySelectorAll('.peak-product-form .peak-purchase-options').forEach((options) => {
  const price = options.closest('.product-copy')?.querySelector('.price');
  if (!price) return;
  const syncPrice = () => {
    const selected = options.querySelector('input[name="selling_plan"]:checked');
    if (selected?.dataset.price) price.textContent = selected.dataset.price;
  };
  options.addEventListener('change', syncPrice);
  syncPrice();
});

// Currency menus keep native form submission and keyboard support.
document.addEventListener('click', (event) => {
  document.querySelectorAll('.peak-currency-menu[open]').forEach((menu) => {
    if (!menu.contains(event.target)) menu.open = false;
  });
});
document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  document.querySelectorAll('.peak-currency-menu[open]').forEach((menu) => {
    menu.open = false;
    menu.querySelector('summary')?.focus();
  });
});
